import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

export const useGoToProfile = () => {
	const { navigate } = useNavigation();

	return useCallback(
		<Row extends { id: string }>(row: Row) => navigate('Profile', { userId: row.id }),
		[navigate],
	);
};
